import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const RequireToken = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("userId");
    setHasToken(!!token);
    setIsChecking(false);
  }, []);

  if (isChecking) return <div>Loading...</div>;
  if (!hasToken) return <Navigate to="/login" replace />;
  return children;
};

export default RequireToken;

